//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

export default {
  name: "ProductTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: function () {
    this.columns = [
      {
        name: "id",
        required: false,
        align: "left",
        label: "ID - Carregamento",
        field: (row) => row.file_upload_id,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "ean",
        required: false,
        label: "EAN",
        align: "left",
        field: (row) => row.ean,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "retailer",
        required: false,
        align: "left",
        label: "Retalhista",
        field: (row) => (row.retailer === null ? null : row.retailer.name),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "retailer-product-description",
        required: false,
        align: "left",
        label: "Descrição Produto RTL",
        field: (row) => row.product_retailer_infos.product_description,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "sku",
        required: false,
        align: "left",
        label: "Código Interno",
        field: (row) => row.product_retailer_infos.internal_code,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "category-code",
        required: false,
        align: "left",
        label: "Segmentação Cód. Categoria",
        field: (row) => row.product_retailer_infos.category_code,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "category-desc",
        required: false,
        align: "left",
        label: "Segmentação Descrição Categoria",
        field: (row) => row.product_retailer_infos.category_description,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "subcategory-code",
        required: false,
        align: "left",
        label: "Segmentação Cód. Sub-categoria",
        field: (row) => row.product_retailer_infos.subcategory_code,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "subcategory-desc",
        required: false,
        align: "left",
        label: "Segmentação Descrição. Sub-categoria",
        field: (row) => row.product_retailer_infos.subcategory_description,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "brand",
        required: false,
        align: "left",
        label: "Segmentação Marca",
        field: (row) => row.product_retailer_infos.brand,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "sub-brand",
        required: false,
        align: "left",
        label: "Segmentação Sub-Marca",
        field: (row) => row.product_retailer_infos.sub_brand,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
    ];
  },
  data: () => ({
    separator: "horizontal",
    columns: [],
    filteredData: [],
  }),
  methods: {
    renderRightSide: function (event) {
      this.$emit("clicked-row", JSON.parse(JSON.stringify(event)));
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};
